// extracted by mini-css-extract-plugin
module.exports = {"form-container":"AddAziendaForm_form-container__84hvx","corsoCard":"AddAziendaForm_corsoCard__3dO9Z","icon":"AddAziendaForm_icon__2Kr9S"};